/* <soh-mobile-drawer>: level 1 + level 2 panels ([data-level-panel="shop"]), back button, body scroll lock. */
class SohMobileDrawer extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('.soh-overlay'); this.panel = this.querySelector('.soh-mobile-drawer__panel');
    document.querySelectorAll('[data-menu-open]').forEach(b => b.addEventListener('click', () => this.open(b)));
    this.addEventListener('click', (e) => {
      if (e.target === this.overlay || e.target.closest('[data-menu-close]')) this.close();
      const go = e.target.closest('[data-level-open]'); if (go) this.level(go.dataset.levelOpen);
      if (e.target.closest('[data-level-back]')) this.level(null);
    });
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
  }
  level(name) {
    this.querySelectorAll('[data-level-panel]').forEach(p => { const on = p.dataset.levelPanel === name; p.hidden = !on; if (on) { const f = p.querySelector('button,a'); f && f.focus(); } });
    this.querySelector('[data-level-root]').hidden = !!name;
  }
  open(btn) { this.btn = btn; this.classList.add('is-open'); this.overlay.classList.add('is-open'); btn && btn.setAttribute('aria-expanded', 'true'); SOH.lockScroll(true); this.release = SOH.trapFocus(this.panel); }
  close() { this.classList.remove('is-open'); this.overlay.classList.remove('is-open'); this.btn && this.btn.setAttribute('aria-expanded', 'false'); this.level(null); SOH.lockScroll(false); this.release && this.release(); this.btn && this.btn.focus(); }
}
customElements.define('soh-mobile-drawer', SohMobileDrawer);
